import type {NavigationGuardReturn, RouteLocationNormalized} from 'vue-router';
import {checkInToken} from '../../api/repositories/CheckInRepository';

export async function handleCheckIn(to: RouteLocationNormalized): Promise<NavigationGuardReturn> {
    const token = to.params.token;

    if (typeof token !== 'string') {
        return {name: 'Login'};
    }

    try {
        const result = await checkInToken(token);

        if (result.ok) {
            return;
        }
    } catch {
        // NOP
    }

    return {name: 'Login'};
}
